import { UserManagement} from './UserManager';
import { DataManagement} from './Database';
import { StorageManagement} from './Storage';
import { AlertFactory } from './Alert';
import { ModalManager} from './Modal';


export const Alert = new AlertFactory();
export const Storage = new StorageManagement();
export const Database = new DataManagement();
export const UserManager = new UserManagement();
export const ModalController = new ModalManager();



